/** Temel geometri ve eylem tipleri — tüm modüllerin paylaştığı dil. */

export type Axis = -1 | 0 | 1;

export interface Point {
  x: number;
  y: number;
}

export interface Direction {
  x: Axis;
  y: Axis;
}

export interface GridSize {
  cols: number;
  rows: number;
}

/** Klavye ve gamepad'in normalleştirildiği ortak eylem seti. */
export type GameAction =
  | "up"
  | "down"
  | "left"
  | "right"
  | "ok"
  | "back"
  | "sound"
  | "pause"
  | "fullscreen";

/** Uygulamanın ekran durumları. */
export type Screen = "title" | "settings" | "game" | "pause" | "over";

/** Bir oyun turunun mantıksal ayarları (UI'dan bağımsız). */
export interface GameOptions {
  baseTickMs: number;
  wallPass: boolean;
  progressive: boolean;
}

export const DIRECTIONS = {
  up: { x: 0, y: -1 } as Direction,
  down: { x: 0, y: 1 } as Direction,
  left: { x: -1, y: 0 } as Direction,
  right: { x: 1, y: 0 } as Direction,
} as const satisfies Record<string, Direction>;

export type DirectionName = keyof typeof DIRECTIONS;

export function isDirectionName(value: string): value is DirectionName {
  return value in DIRECTIONS;
}
